import { observer } from 'mobx-react-lite';
import FilePickerErrorMessageType, {
    errorMessageMap,
    FilePickerErrorMessage,
} from '../types/FilePickerErrorMessageType';
import { trace } from 'owa-trace';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./FilePickerErrorMessageView.scss');

export interface FilePickerErrorMessageViewProps {
    message: FilePickerErrorMessageType;
}

export default observer(function FilePickerErrorMessageView(
    props: FilePickerErrorMessageViewProps
) {
    const getErrorMessage = React.useRef(function getErrorMessage(
        message: FilePickerErrorMessageType
    ): FilePickerErrorMessage {
        if (message in errorMessageMap) {
            return errorMessageMap[message]();
        }
        trace.error('invalid errorMessageType given. Showing generic error message');
        return errorMessageMap[FilePickerErrorMessageType.Generic]();
    });
    const errorMessage = getErrorMessage.current(props.message);
    return (
        <div className={styles.container}>
            <span className={classNames(errorMessage.icon, styles.emptyStateIcon)} />
            <div className={styles.emptyStateMessage}> {errorMessage.message} </div>
            {errorMessage.messageSubtext && (
                <div className={styles.emptyStateMessageSubtext}>
                    {' '}
                    {errorMessage.messageSubtext}{' '}
                </div>
            )}
        </div>
    );
});
